// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BumI","col":"styles_col__2Hve8","actions":"styles_actions__M190O","conflict":"styles_conflict__3CxLq"};